 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		17: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		17: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "javascripts/chunks/" + {"0":"5f84fb449b67c5b7947e","1":"a256dd756f562835c501","2":"12ff3843abefd21e28e0","3":"bd7df411b53470d5332c","4":"e95d84dcb854609d6ac3","5":"e403220aa591f5d32d5f","6":"e7fe5d14b042db89559f","7":"e0a0f3090b6fcd717401","8":"072a248b18774ecf7263","9":"46a2abb4d2188252d1df","10":"d3d335e71d68332ea60a","11":"3e7129d225691845e56c","12":"85d4410bb9f68fb027e5","13":"5526fe1262488d3e21ff","14":"c048599c5ccd269ec02e","15":"86beb3fe9bf07d2d2bff","16":"9fb545cf0d2aec83a878","18":"0653b30f117db162da8f","19":"73e172dcce4d58610ac4","20":"cbb3b88393960e25d309","21":"67b79786eae6cb4ce93e","22":"3df5ff959e00fb6c52d2","23":"5a6f1c414a81fd313f40","24":"992e93d2b4201f246b12","25":"d8c79e1881f4d489134f","26":"59f709363b5167df756f","27":"2fe24ddd45b414c55a96","28":"4703dc467094d7fc70ff","29":"d3832f925ac0530c3247","30":"abd1875667e1e8376fa4","31":"e9261806c4e44018af91","32":"a31b400368bc398831d1","33":"fd6f9ad1bd963fd89393","34":"74f2e5444eede3473662","35":"43a6047826e1d80b6c15","36":"0852d6f6587f2b8f901d","37":"0d241697e09fd7da5748","38":"b45d56fdad4a679e9da1","39":"02e50fbfb65022c36106","40":"c21631be5b893f00ccde","41":"f2da559364b78e5a7b1e","42":"3b886335fff25991ec40","43":"8ffe4931a1b605aae7ce","44":"531e972cba6e93ed6138","45":"6d7fa72d05922522f4ad"}[chunkId] + "." + ({"2":"chart~investment-advice","3":"vendors~business~scrolling-text","4":"vendors~chart~investment-advice","5":"accordion","6":"block-media","7":"business","8":"chart","9":"contact","10":"faq-container","11":"fixing-rates","12":"form","13":"gallery","14":"investment-advice","15":"investor-profile","16":"inxmail","18":"menubar","19":"modal","20":"movingGradient","21":"navigation","22":"notification","23":"popup","24":"quote","25":"scrolling-text","26":"search","27":"stage-home","28":"tabs","29":"tombstones","30":"tooltip","31":"top-btn","32":"vendors~form","33":"vendors~gallery","34":"vendors~investment-advice","35":"vendors~navigation","36":"vendors~quote","37":"vendors~scrolling-text","38":"vendors~search","39":"vendors~tabs","40":"vendors~tooltip","41":"video"}[chunkId]||chunkId) + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"32":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "chunks/" + {"0":"5f84fb449b67c5b7947e","1":"a256dd756f562835c501","2":"12ff3843abefd21e28e0","3":"bd7df411b53470d5332c","4":"e95d84dcb854609d6ac3","5":"e403220aa591f5d32d5f","6":"e7fe5d14b042db89559f","7":"e0a0f3090b6fcd717401","8":"072a248b18774ecf7263","9":"46a2abb4d2188252d1df","10":"d3d335e71d68332ea60a","11":"3e7129d225691845e56c","12":"85d4410bb9f68fb027e5","13":"5526fe1262488d3e21ff","14":"c048599c5ccd269ec02e","15":"86beb3fe9bf07d2d2bff","16":"9fb545cf0d2aec83a878","18":"0653b30f117db162da8f","19":"73e172dcce4d58610ac4","20":"cbb3b88393960e25d309","21":"67b79786eae6cb4ce93e","22":"3df5ff959e00fb6c52d2","23":"5a6f1c414a81fd313f40","24":"992e93d2b4201f246b12","25":"d8c79e1881f4d489134f","26":"59f709363b5167df756f","27":"2fe24ddd45b414c55a96","28":"4703dc467094d7fc70ff","29":"d3832f925ac0530c3247","30":"abd1875667e1e8376fa4","31":"e9261806c4e44018af91","32":"a31b400368bc398831d1","33":"fd6f9ad1bd963fd89393","34":"74f2e5444eede3473662","35":"43a6047826e1d80b6c15","36":"0852d6f6587f2b8f901d","37":"0d241697e09fd7da5748","38":"b45d56fdad4a679e9da1","39":"02e50fbfb65022c36106","40":"c21631be5b893f00ccde","41":"f2da559364b78e5a7b1e","42":"3b886335fff25991ec40","43":"8ffe4931a1b605aae7ce","44":"531e972cba6e93ed6138","45":"6d7fa72d05922522f4ad"}[chunkId] + "." + chunkId + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");

 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				var onLinkComplete = function (event) {
 					// avoid mem leaks.
 					linkTag.onerror = linkTag.onload = null;
 					if (event.type === 'load') {
 						resolve();
 					} else {
 						var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 						var realHref = event && event.target && event.target.href || fullhref;
 						var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + realHref + ")");
 						err.code = "CSS_CHUNK_LOAD_FAILED";
 						err.type = errorType;
 						err.request = realHref;
 						delete installedCssChunks[chunkId]
 						linkTag.parentNode.removeChild(linkTag)
 						reject(err);
 					}
 				};
 				linkTag.onerror = linkTag.onload = onLinkComplete;
 				linkTag.href = fullhref;

 				document.head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/assets/nomodule/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 122);
